export default "__VITE_ASSET__DXrRVToZ__"